import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useMatch, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import { AppRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
//import { TestSereisRouteURL } from "@Constants/app-route-url.constant";
import DashBoardSvg from "@Assets/svg/Dashboard-svgs/Dahboard.svg";
import MocktestSvg from "@Assets/svg/Dashboard-svgs/MockTest.svg";
import LeaderboardSvg from "@Assets/svg/Dashboard-svgs/LeaderBoar.svg";
import ActiveDashboardSvg from "@Assets/svg/Dashboard-svgs/ActiveDashboard.svg";
import ActiveMocktestSvg from "@Assets/svg/Dashboard-svgs/ActiveMocktest.svg";
import ActiveLeaderboardSvg from "@Assets/svg/Dashboard-svgs/ActiveLeaderboard.svg";
import Logoutsvg from "@Assets/svg/Dashboard-svgs/Logout.svg";
import { setUserID } from "@Src/app/reducers/auth/registerSlice";
import { clearUserData } from "@Src/app/reducers/auth/loginSlice";
import { clearCoursePreferences } from "@Src/app/reducers/auth/coursePreferencesSlice";
import { useAppDispatch } from "@Src/app/hooks";
import toast from "react-hot-toast";
import SvgIcon from "@Components/icons/SvgIcon";
import { getUserDetails } from "@Src/features/UserProfile/Services/UserProfile.sevice";




export const DashboardSidebarIndex = ({ closeSidebar }: { closeSidebar?: () => void }) => {
  const dispatch = useAppDispatch();
  //  let match = useMatch({ path: AppRouteURL.DASHBOARD + AppRouteURL.MOCKTEST + '/20' , end: true });
  const matchMockTestURL = useLocation().pathname.includes(`${AppRouteURL.MOCKTEST}`)
  const [userInfo, setUserInfo] = useState<any>();
  const logout = () => {
    dispatch(clearUserData());
    dispatch(clearCoursePreferences());
    toast.success('Student loggged out successfully');
  }

  const fetchUserDetails = async () => {
    try {
      const response = await getUserDetails();
      if (response.success && response.data?.[0]) {
        const userData = response.data[0];
        setUserInfo(userData);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  return (
    <>
      <div className="dashboard-sidebar-container">
        <ul className="dashboard-ul-card">

          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.DASHBOARD_HOME} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon
                  name="dashboard"
                />
              </span>
              Dashboard
            </NavLink>
          </li>
          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.USERPROFILE + AppRouteURL.COURSEPREFERD} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon
                  name="coursePreferences" />
              </span>
              Study Profile
            </NavLink>
          </li>
          <li onClick={closeSidebar}>
            <NavLink to={TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="mockTest" />
              </span>
              Readiness Check
            </NavLink>
          </li>
          <li onClick={closeSidebar}>
            <NavLink to={TestSereisRouteURL.TEST_SERIES} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="mockTest" />
              </span>
              Practice Test
            </NavLink>
          </li>
          <li onClick={closeSidebar}>
            <NavLink to={TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="mockTest" />
              </span>
              Previous Year Test
            </NavLink>
          </li>
          <li onClick={closeSidebar}>
            <NavLink to={TestSereisRouteURL.FULL_MOCK_TEST_SERIES} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="mockTest" />
              </span>
              Mock Test
            </NavLink>
          </li>

          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.TEST_ACTIVITY} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="testCompleted" />
              </span>
              My Test
            </NavLink>
          </li>

          {/* <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.VIDEO_BRANCHING} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon
                  name="video" />
              </span>
              Concept Videos
            </NavLink>
          </li> */}


          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.VIDEO_LISTING} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon
                  name="video" />
              </span>
              Videos
            </NavLink>
          </li>

          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.MIND_MAP} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="mindMap" />
              </span>
              Revision Hub
            </NavLink>
          </li>

          {/* <li>
            <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.MOCKTEST} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
                <span>
                  <SvgIcon name="testCompleted" />
                </span>
              Test Completed
            </NavLink>
          </li>

          <li>
            <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.MOCKTEST} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
                <span>
                <SvgIcon name="testPending" />
                </span>
              Test Pending
            </NavLink>
          </li> */}

          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.USERPROFILE + AppRouteURL.MYPROFILE} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="myProfile" />
              </span>
              My Profile
            </NavLink>
          </li>

          {
            (userInfo?.RegisteredFrom === "api") && <li onClick={closeSidebar}>
              <NavLink to={AppRouteURL.USERPROFILE + AppRouteURL.CHANGEPASS} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
                <span>
                  <SvgIcon name="changePassword"
                  />
                </span>
                Change Password
              </NavLink>
            </li>
          }

          <li onClick={closeSidebar}>
            <NavLink to={AppRouteURL.CONTACT} className={({ isActive }) => isActive ? 'navlink-li active' : 'navlink-li'}>
              <span>
                <SvgIcon name="contectUs" />
              </span>
              Contact Us
            </NavLink>
          </li>          {/* {matchMockTestURL ? <li>
            <NavLink to={AppRouteURL.MOCKTEST} onClick={(e) => e.preventDefault()} className={({ isActive }) => isActive ? 'active-navlink-li' : 'navlink-li'}>
              <span className="dashboard-svg">
                <img className="dash-img-svg" src={MocktestSvg} alt="dashboard-img" />
                <img className="active-dash-img-svg" src={ActiveMocktestSvg} alt="dashboard-img" />
              </span>
              Mock Test</NavLink>
          </li> : ''} */}

          {/* <li>
          <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.LEADEBOARD} className={({isActive}) => isActive? 'active-navlink-li' : 'navlink-li' }>
            <span className="dashboard-svg">
            <img className="dash-img-svg" src={LeaderboardSvg} alt="dashboard-img" />
            <img className="active-dash-img-svg" src={ActiveLeaderboardSvg} alt="dashboard-img" />
            </span>
            Leaderboard</NavLink>
          </li> */}

          {/* <li>
          <NavLink to={AppRouteURL.DASHBOARD + AppRouteURL.MYBADGES} className={({isActive}) => isActive? 'active-navlink-li' : 'navlink-li' }>
            <span className="dashboard-svg">
            <img className="dash-img-svg" src={BadgeSvg} alt="dashboard-img" />
            <img className="active-dash-img-svg" src={ActiveBadgeSvg} alt="dashboard-img" />
            </span>
            My Badges</NavLink>
          </li> */}
        </ul>


        {/* <ul className="logout-ul-card">
          <li>
            <Link to="/" >
              <a className="logout-li-tag" onClick={() => logout()}>
                <span className="logout-svg">
                  <img src={Logoutsvg} alt="logout-svg" />

                </span>
                Logout</a>
            </Link>
          </li>
        </ul> */}
      </div>
    </>
  );
};
